import React, { useState } from 'react'
import { DataContext } from '../../helper/HelperOne';
import NavBar from '../nav_bar/Navbar';
import LeadTaskCreate from './LeadTaskCreate';

function LeadTask() {
    const [searchUi, setSearchUi] = useState(true);
    const [searchData, setSearchData] = useState(null);

    return (
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadTaskCreate />}
                menuId={20}
            />
        </DataContext.Provider>
    );
}

export default LeadTask